export const ActionType = Object.freeze({
    SubmitForm: 'submitForm',
    MutateScreenNoPostDataAction: 'mutateScreenNoPostDataAction',
    ReloadScreenWithPostDataAction: 'reloadScreenWithPostDataAction',
    MutateComponentOrReloadScreenWithPostDataAction: 'mutateComponentOrReloadScreenWithPostDataAction',
    DownloadFileAction: 'downloadFileAction',
    MutateScreenWithPostDataAction: 'mutateScreenWithPostDataAction',
    RedirectFrontEnd: 'redirectFrontEnd',
    PostDataAndRedirectFrontEnd: 'postDataAndRedirectFrontEnd',
    OpenModalFormAction: 'openModalFormAction',
    ExternalSiteLink: 'externalSiteLink',

    MutateComponentWithPostDataAction: 'mutateComponentWithPostDataAction',
    MutateComponentNoPostDataAction: 'mutateComponentNoPostDataAction',
    ExternalRedirect: 'externalRedirect',
    LogoutAction: 'logoutAction',
});
